import ToolTag from "./ToolTag";
import WorkTile from "./WorkTile";

const WorkCollection = ({ data }) => {
  return (
    <div className="work-collection">
      <div className="work-collection__tools">
        {data.tools.map((tool) => (
          <ToolTag key={tool}>{tool}</ToolTag>
        ))}
      </div>
      <div className="work-collection__tile-group">
        {data.projects.map((project) => (
          <WorkTile key={project.name} project={project} />
        ))}
      </div>
    </div>
  );
};

export default WorkCollection;
